module.exports = __webpack_public_path__ + "static/pig-572f5f63c3155c2cb087105d7caa59d5.png";